function randomBytes(size: number): Uint8Array {
  // Browser
  const webCrypto = (globalThis as any).crypto;
  if (webCrypto && typeof webCrypto.getRandomValues === "function") {
    const bytes = new Uint8Array(size);
    webCrypto.getRandomValues(bytes);
    return bytes;
  }

  // Node
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const nodeCrypto = require("crypto") as typeof import("crypto");
  return new Uint8Array(nodeCrypto.randomBytes(size));
}

export function uuidv4(): string {
  const webCrypto = (globalThis as any).crypto;
  if (webCrypto && typeof webCrypto.randomUUID === "function") {
    return webCrypto.randomUUID();
  }

  const bytes = randomBytes(16);
  const byteArray = Array.prototype.slice.call(bytes) as number[];
  let hex = "";
  for (const b of byteArray) {
    hex += b.toString(16).padStart(2, "0");
  }

  // Set RFC 4122 version (4) and variant (10xx) without bitwise ops.
  // Byte 6 (chars 12-13) high nibble = 4
  hex = `${hex.slice(0, 12)}4${hex.slice(13)}`;

  // Byte 8 (chars 16-17) high nibble = 8..b (10xx)
  const variantNibble = hex.slice(16, 17);
  const variantNibbleInt = parseInt(variantNibble, 16);
  const low2Bits = variantNibbleInt % 4; // keep low 2 bits
  const newVariantInt = 8 + low2Bits; // force top bits to 10
  hex = `${hex.slice(0, 16)}${newVariantInt.toString(16)}${hex.slice(17)}`;

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(
    12,
    16
  )}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}



// WEBPACK FOOTER //
// ./src/utils/uuid.ts